/// <amd-module name="Wit/Common/WitSettingsViews/Components/CriteriaTable/CriteriaInterfaces" />
import { IObservableArray, IObservableValue, IReadyableObservableArray } from "VSS/Core/Observable";
import { IListBoxItem } from "VSSUI/ListBox";
import { DropdownSelection } from "VSSUI/Utilities/DropdownSelection";

/**
 * Represent selected value of the criteria setting
 */
export interface ICriteriaSelectedSettingData {
    /**
     * Currently selected field
     */
    field: string;

    /**
     * Currently selected operator
     */
    operator: string;

    /**
     * Currently selected value
     */
    criteriaValue: IObservableValue<string>;
}

/**
 * Represent each row of the criteria setting
 */
export interface ICriteriaSettingData extends ICriteriaSelectedSettingData {
    /**
     * Available values in the dropdown
     */
    criteriaValues: IReadyableObservableArray<string>;

    /**
     * Available fields in the dropdown
     */
    fields: IObservableArray<IListBoxItem>;
    fieldSelection: DropdownSelection;

    /**
     * Unique identifier used to create unique React keys
     */
    id: string;

    /**
     * Available operator options in the dropdown
     */
    operators: IObservableArray<IListBoxItem>;
    operatorSelection: DropdownSelection;

    /**
     * Indicates if the currently selected value is invalid
     */
    hasError: IObservableValue<boolean>;
}

/**
 * Filter Clause constants
 */
export namespace FilterClauseConstants {
    /**
     * AND operator
     */
    export const andOperator = "AND";
}
